import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { defaultQueryFn } from "./actions/defaultQuery";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "sweetalert2/src/sweetalert2.scss";
import { RecoilRoot } from "recoil";
import { CookiesProvider } from "react-cookie";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
    },
  },
});
ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <ReactNotification />
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </CookiesProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
